var $j = jQuery.noConflict();

$j( '.footer-menu .widget-title' ).click(
	function(e) {
		e.preventDefault();

		if ($j( window ).width() < 981) {

			var $this = $j( this );

			if ($this.next().hasClass( 'show' )) {
				$this.next().removeClass( 'show' );
				$this.next().slideUp( 350 );
			} else {
				$this.parent().parent().parent().find( '.widget_nav_menu > div' ).removeClass( 'show' );
				$this.next().toggleClass( 'show' );
			}
		}
	}
);
